<template>
  <div class="dialog-wrap">
    <el-dialog
      title="消息编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
       <el-form-item label="消息分类" prop="category_id">
          <el-select v-model="dataForm.category_id" placeholder="选择分类" style="width: 100%">
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息标题" prop="title">
          <el-input v-model="dataForm.title" placeholder="请输入消息标题"></el-input>
        </el-form-item>
        <el-form-item label="消息描述" prop="description">
          <el-input v-model="dataForm.description" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入消息描述"></el-input>
        </el-form-item>
        <el-form-item label="消息链接" prop="link_url">
          <el-input v-model="dataForm.link_url" placeholder="请输入消息链接"></el-input>
        </el-form-item>
        <el-form-item label="消息封面" prop="picture_url">
          <el-upload
            class="cover-uploader"
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload">
            <img v-if="dataForm.picture_url" :src="dataForm.picture_url" class="cover">
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div class="ref-box">
          <el-form-item label="关联类型">
            <el-select v-model="dataForm.ref_type" placeholder="请选择关联类型" style="width: 100%;" @change="handleTypeChange">
              <el-option
                v-for="item in refTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联内容">
            <el-input v-model="dataForm.ref_content.name" :disabled="dataForm.ref_type == 0" placeholder="请选择关联内容" @focus="handleContentChoose"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <ContentChoose
      :visible="contentChooseDialog"
      @close="contentChooseDialog = false"
      @submit="handleContentChooseSave"
      :ref_type ="dataForm.ref_type"
    ></ContentChoose>
  </div>
</template>

<script>
import ContentChoose from "@/components/dialog/ContentChoose";
import { noticeUpdate, noticeCategoryList } from '@/api/operation'
import { imgUploadUrl, uploadHeaders } from '@/config/index'

export default {
  components: {
    ContentChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      contentChooseDialog: false,
      dataForm: this.content || {
        picture_url: '',
        ref_type: 0,
        ref_content: {}
      },
      categorys: [],
      refTypes: [
        {label: '无关联', value: 0},
        {label: '课程', value: 1},
        {label: '题库', value: 2},
        {label: '阅读资料', value: 3},
        {label: '实体资料', value: 4},
        {label: '信息资讯', value: 5}
      ],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {
        category_id: [{ required: true, message: '请选择消息分类', trigger: 'change' }],
        title: [{ required: false, message: '请输入消息标题', trigger: 'blur' }],
        link_url: [{ required: false, message: '请输入消息链接', trigger: 'blur' }],
        picture_url: [{ required: false, message: '请上传消息封面', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchCategoryList()
      }
    },
    content (val) {
      this.dataForm = val
      this.dataForm.ref_content = this.dataForm.ref_content || {}
    }
  },
  methods: {
    // 分类列表请求
    fetchCategoryList() {
      noticeCategoryList({status: 1, isPaging: 0}).then(res => {
        let list = res.list || []
        this.categorys = list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (!this.dataForm.title && !this.dataForm.picture_url) {
            this.$message.warning(`这也太空了吧，标题、图片至少二选一哟～`)
            return
          }
          const params = {
            id: this.dataForm.id,
            category_id: this.dataForm.category_id,
            title: this.dataForm.title,
            description: this.dataForm.description,
            link_url: this.dataForm.link_url,
            picture_url: this.dataForm.picture_url,
            ref_type: this.dataForm.ref_type,
            ref_id: this.dataForm.ref_id
          }
          noticeUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.picture_url = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleTypeChange(value) {
      this.dataForm.ref_id = null
      this.dataForm.ref_content = {}
    },
    handleContentChoose() {
      this.contentChooseDialog = true
    },
    handleContentChooseSave(value) {
      this.dataForm.ref_id = value.id
      this.dataForm.ref_content = value
    }
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;

      .cover-uploader /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 100%;
      }
      .cover-uploader /deep/ .el-upload:hover {
        border-color: #409EFF;
      }
      .cover-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      .cover {
        display: block;
        width: 100%;
        height: 100px;
        object-fit: cover;
      }
      .ref-box {
        /deep/ .el-input__inner {
          border-style: dashed;
        }
      }
    }
  }
</style>
